import { HttpService } from "./http.service";

const basePath = "/Profile";
const request = HttpService.handleRequest();

export const ProfileService = {
  getAll
};

async function getAll() {
  return request.get(basePath);
}

export default ProfileService;